var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.335,
    height: 6.201,
    viewBox: "0 0 10.335 6.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_back",
    "data-name": "arrow back",
    d: "M5.168,6.2a.938.938,0,0,1-.723-.31L.31,1.757A1,1,0,0,1,.31.31a1,1,0,0,1,1.447,0L5.168,3.721,8.578.31a1,1,0,0,1,1.447,0,1,1,0,0,1,0,1.447L5.891,5.891A.938.938,0,0,1,5.168,6.2Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowWhite);
export default __webpack_public_path__ + "static/media/down_arrow_white.2a2466393b1aa09af76ada0ab1bac93b.svg";
export { ForwardRef as ReactComponent };